import TipoUsuarioService from "@/services/TipoUsuarioService";

export const tipoUsuario = {
  namespaced: true,
  state: {
    tipoUsuario: {},
  },
  actions: {
    getTipoUsuario({ commit }, payload) {
      return TipoUsuarioService.GetTipoUsuario(payload).then(
        (tipoUsuario) => {
          return Promise.resolve(tipoUsuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTipoUsuario({ commit }, payload) {
      return TipoUsuarioService.PostTipoUsuario(payload).then(
        (tipoUsuario) => {
          return Promise.resolve(tipoUsuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTipoUsuario({ commit }, payload) {
      return TipoUsuarioService.PutTipoUsuario(payload).then(
        (tipoUsuario) => {
          return Promise.resolve(tipoUsuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTipoUsuario({ commit }, payload) {
      return TipoUsuarioService.DeleteTipoUsuario(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTipoUsuarioOData({ commit }, payload) {
      return TipoUsuarioService.GetTipoUsuarioOData(payload).then(
        (tipoUsuario) => {
          return Promise.resolve(tipoUsuario);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tipoUsuario;
